<template>
    <v-content>
        <v-row class="pb-0 pb-sm-10">
            <v-col class="display-1">
                События
            </v-col>
        </v-row>

        <div class="table-filters">
            <v-row>
                <v-col cols="4">
                    <div class="w100">
                        <p class="text-field-header">Роль:</p>
                        <v-select
                            v-model="filters.role"
                            :items="roles"
                            label="Выберите роль"
                            item-text="description"
                            item-value="name"
                            single-line
                            outlined
                            dense
                        ></v-select>
                    </div>
                </v-col>
                <v-col cols="4">
                    <p class="text-field-header">Пользователи:</p>
                    <MultiplySelect
                        :model.sync="filters.user_ids"
                        :options="users"
                        field="email"
                        value="id"
                        :dense="true"
                        placeholder="Выберите пользователей"
                    >
                    </MultiplySelect>
                </v-col>
                <v-col cols="4">
                    <div class="w100">
                        <p class="text-field-header">События:</p>
                        <MultiplySelect
                            :model.sync="filters.events"
                            :options="events"
                            :dense="true"
                            placeholder="Выберите события"
                            field="description"
                            value="name"
                        >
                        </MultiplySelect>
                    </div>
                </v-col>
            </v-row>
            <v-row class="mt-n6 mb-12">
                <v-col>
                    <div class="float-right">
                        <v-btn color="info" @click="resetFilters()">Сбросить фильтр</v-btn>
                        <v-btn class="ml-4" color="primary" depressed @click="paginate()"
                            >Фильтровать</v-btn
                        >
                    </div>
                </v-col>
            </v-row>
        </div>

        <v-row>
            <v-data-table
                class="w100"
                :headers="headers"
                :items="tableItems"
                :options.sync="pagination"
                :server-items-length="total"
                :loading="isLoading"
            >
                <template v-slot:item.actions="{ item }">
                    <div class="mt-2">
                        <v-btn outlined color="info" small @click="info(item)">Подробнее</v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-row>
        <EventDetailModal></EventDetailModal>
    </v-content>
</template>

<script>
import MultiplySelect from "@/app/shared/components/form-inputs/MultiplySelect";
import EventDetailModal from "../components/eventDetailModal";
import eventService from "../services/eventService";
export default {
    name: "EventsTable",
    components: {
        MultiplySelect,
        EventDetailModal,
    },
    data() {
        return {
            roles: eventService.getRoles(),
            pagination: {
                page: 1,
                itemsPerPage: 15,
                sortBy: ["id"],
                sortDesc: [true],
            },
            filters: {},
            headers: [
                { text: "ID", sortable: true, value: "id" },
                { text: "Событие", sortable: false, value: "eventFormatted" },
                { text: "Роль", sortable: false, value: "roleFormatted" },
                { text: "Пользователь", sortable: false, value: "userFormatted" },
                { text: "Дата создания", sortable: false, value: "createdAtFormatted" },
                { text: "Действия", value: "actions", sortable: false },
            ],
        };
    },
    created() {
        this.$store.dispatch("FETCH_EVENT_LIST");
        this.$store.dispatch("FETCH_USER_LIST");
        this.paginate();
    },
    computed: {
        tableData() {
            return this.$store.getters.EVENT_PAGINATION_DATA;
        },
        tableItems() {
            return this.$store.getters.EVENT_PAGINATION_ITEMS;
        },
        isLoading() {
            return this.$store.getters.EVENT_PAGINATION_LOADING;
        },
        total() {
            const { total } = this.tableData;
            return total || 0;
        },
        users() {
            return this.$store.getters.USER_SELECT_LIST;
        },
        events() {
            return this.$store.getters.EVENT_LIST;
        },
    },
    methods: {
        paginate() {
            this.$store.dispatch("EVENT_PAGINATION", {
                pagination: this.pagination,
                filters: this.filters,
            });
        },
        info(event) {
            this.$store.dispatch("SHOW_EVENT_DETAIL_MODAL", event);
        },
        resetFilters() {
            this.filters = {};
            this.paginate();
        },
    },
    watch: {
        pagination: {
            handler() {
                this.paginate();
            },
            deep: true,
        },
    },
};
</script>
